import { DataFetchWrapper } from "@tfg/ui"

import { ProductMapping } from "~/pages/Brand/OrganizationSettings/Mapping/Product/ProductMapping.tsx"
import { useFindMappingByTypeQuery } from "~/pages/Brand/OrganizationSettings/Mapping/hooks/useFindMappingByTypeQuery.ts"

export const ProductMappingWrapper = () => {
  const query = useFindMappingByTypeQuery("PRODUCT")

  return (
    <DataFetchWrapper query={query} acceptEmpty>
      {({ data }) => <ProductMapping productTypes={data.data} />}
    </DataFetchWrapper>
  )
}
